import { PropsWithChildren } from "react";
import Title from "../Title";

interface MobileHeaderProps {
  title: string;
}

export default function MobileHeader({
  title,
  children,
}: PropsWithChildren<MobileHeaderProps>) {
  return (
    <>
      <div className="bg-white wish-bg-white fixed z-10 flex w-full flex-col justify-between md:hidden">
        <Title>{title}</Title>
      </div>
      <div className="fixed z-20 flex h-12 w-full flex-row-reverse items-center justify-between md:hidden">
        {children}
      </div>
      <div className="h-12 md:hidden"></div>
    </>
  );
}
